import { useEffect } from 'react';
import { SEARCH_TYPE } from '@/constants/searchType';
import { RESULT_DISPLAY_TYPE } from '@/constants/resultDisplay';
import { useAnimalDisplayType } from '@/hooks/publicSearch/animal/useAnimalDisplayType';
import { useEbvDisplayOptions } from '@/hooks/publicSearch/useEbvDisplayOptions';
import { useIsEbvEnabled } from '@/hooks/publicSearch/useIsEbvEnabled';
import { useSearchType } from '@/hooks/publicSearch/useSearchType';
import useGridStore from '@/publicSearch/store/useGridStore';
import { searchApiRef } from '../../searchSection/PublicSearchDataGrid';

export function useSearchDisplayEffects() {
  const searchType = useSearchType();
  const { resultDisplay } = useAnimalDisplayType();
  const isEbvEnabled = useIsEbvEnabled();
  const { showPercentileSearch } = useEbvDisplayOptions();
  const {
    showEBVs,
    showEBVAccuracy,
    showPercentiles,
    setShowEBVs,
    setShowEBVAccuracy,
    setShowPercentiles,
  } = useGridStore();

  const isCardView = resultDisplay === RESULT_DISPLAY_TYPE.GALLERY;
  const showAnimalToggles = searchType === SEARCH_TYPE.ANIMAL;
  const showDetailToggles =
    searchType === SEARCH_TYPE.SALE_CATALOGUES_DETAIL_ANIMALS ||
    searchType === SEARCH_TYPE.SEMEN_CATALOGUES_DETAIL_ANIMALS;

  useEffect(() => {
    if (!isEbvEnabled) {
      setShowEBVs(false);
      setShowEBVAccuracy(false);
      setShowPercentiles(false);
    }
  }, [isEbvEnabled, setShowEBVs, setShowEBVAccuracy, setShowPercentiles]);

  useEffect(() => {
    if (!showPercentileSearch) setShowPercentiles(false);
  }, [setShowPercentiles, showPercentileSearch]);

  useEffect(() => {
    if ((!showAnimalToggles && !showDetailToggles) || isCardView) return;
    const frame = window.requestAnimationFrame(() => {
      searchApiRef.current?.autosizeColumns?.({
        includeHeaders: true,
        includeOutliers: true,
        expand: true,
      });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [
    isCardView,
    showAnimalToggles,
    showDetailToggles,
    showEBVs,
    showEBVAccuracy,
    showPercentiles,
  ]);
}
